(function () {
  'use strict';

  // Texture de fond décorative supprimée (17 Ko naviplus évitables) — fond CSS uni du drawer.
  const BG_TEXTURE = '';
  const TRIGGER =
    'button[aria-controls="lgk-navi-slide"], button[data-lgk-navi-trigger], button[aria-controls="sidebar-menu"]';

  const PAGE_MAP = {
    index: ['index'],
    products: ['product'],
    collections: ['collection', 'list-collections'],
    pages: ['page'],
    blogs: ['blog', 'article'],
    others: ['cart', 'search', '404', 'password', 'gift_card'],
  };

  function pageAllowed(displayPages, pageType) {
    if (!displayPages || !displayPages.length) return true;
    for (const key of displayPages) {
      const types = PAGE_MAP[key];
      if (types && types.includes(pageType)) return true;
    }
    return displayPages.includes('others') && !Object.values(PAGE_MAP).flat().includes(pageType);
  }

  function esc(s) {
    return String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function px(val, fallback) {
    if (!val && val !== 0) return fallback || '';
    const n = String(val);
    return /^\d+$/.test(n) ? n + 'px' : n;
  }

  const DEAD_UPLOADER = /naviplus\.b-cdn\.net\/uploader\//i;

  function fixImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    let u = url.trim();
    if (!u) return '';
    if (!/^https?:\/\//i.test(u)) {
      if (/^legeekshop\.com/i.test(u) || /^www\.legeekshop\.com/i.test(u)) {
        u = 'https://' + u.replace(/^https?:\/\//, '');
      } else if (u.includes('cdn/shop/')) {
        u = 'https://www.legeekshop.com/' + u.replace(/^\/+/, '');
      }
    }
    return shrinkCdnImage(u);
  }

  // Vignettes icônes ≤ 80 px : 160 px webp. Les grid-tiles Deal/Candy/Wayne
  // redimensionnent ensuite via withImageWidth() à l’affichage.
  function shrinkCdnImage(u) {
    if (!/cdn\/shop\//i.test(u) && !/cdn\.shopify\.com/i.test(u)) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.includes('?') ? '&' : '?') + 'width=160&format=webp';
  }

  function withImageWidth(u, w) {
    if (!u) return u;
    if (/[?&]width=\d+/i.test(u)) return u.replace(/([?&]width=)\d+/i, `$1${w}`);
    return u + (u.includes('?') ? '&' : '?') + `width=${w}&format=webp`;
  }

  function ensureRemixIconCss() {
    if (document.getElementById('lgk-remixicon-css')) return;
    const link = document.createElement('link');
    link.id = 'lgk-remixicon-css';
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/remixicon@4.6.0/fonts/remixicon.css';
    document.head.appendChild(link);
  }

  function normalizeMenuData(data, shopLogo) {
    const logo = shopLogo || (typeof window !== 'undefined' && (window.__lgkCandyLogo || window.__lgkDealLogo || window.__lgkDigitalLogo)) || '';
    function walk(items) {
      items.forEach((item) => {
        if (item.image) {
          item.image = fixImageUrl(item.image);
          if (!item.image || DEAD_UPLOADER.test(item.image)) {
            if (item.kind === 4 || /legeekshop|logo|candy geekland|deal geekland|digital geekland/i.test(item.name || '')) {
              item.image = logo;
            } else {
              item.image = '';
            }
          }
        } else if (
          logo &&
          item.kind === 4 &&
          (item.layout?.display === 'top-down' ||
            /brand/i.test(item.className || '') ||
            /candy geekland|deal geekland|digital geekland|wayne outfitters|legeekshop|gotham airsoft|fivem/i.test(item.name || ''))
        ) {
          item.image = logo;
        }
        if (item.style?.bgImage) item.style.bgImage = fixImageUrl(item.style.bgImage);
        if (item.children?.length) walk(item.children);
      });
    }
    if (Array.isArray(data.items)) walk(data.items);
    return data;
  }

  function mediaBoxStyle(item) {
    const st = item.style || {};
    const parts = [];
    if (st.iconBoxColor) parts.push(`background:${st.iconBoxColor}`);
    if (st.iconBoxRadius) parts.push(`border-radius:${px(st.iconBoxRadius)}`);
    if (st.iconBoxPadding) parts.push(`padding:${px(st.iconBoxPadding)}`);
    if (st.iconColor && item.icon) parts.push(`color:${st.iconColor}`);
    return parts.length ? ` style="${esc(parts.join(';'))}"` : '';
  }

  function iconFallbackMarkup(item) {
    if (!item.icon || !item.icon.startsWith('ri-')) return '';
    const size = item.style?.iconSize || '';
    const iconStyle = size && Number(size) <= 120 ? ` style="font-size:${esc(px(size))}"` : '';
    return `<span class="lgk-navi-slide__media"${mediaBoxStyle(item)}><i class="${esc(item.icon)} lgk-navi-slide__icon"${iconStyle} aria-hidden="true"></i></span>`;
  }

  function applyItemStyle(el, item, opts = {}) {
    const st = item.style || {};
    if (st.textSize) el.style.setProperty('--lgk-navi-row-title', px(st.textSize));
    if (st.textColor) el.style.color = st.textColor;
    if (opts.compact) return;
    if (st.bgColor) el.style.backgroundColor = st.bgColor;
    const bg = st.bgImage || '';
    if (bg) {
      el.style.backgroundImage = `url(${bg})`;
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center';
    }
    if (st.padding) el.style.padding = px(st.padding);
    if (st.margin) el.style.margin = px(st.margin);
    if (st.align && st.align !== 'inherit') {
      const isListRow =
        el.classList.contains('lgk-navi-slide__row') ||
        el.classList.contains('lgk-navi-slide__row-btn');
      if (!isListRow) el.style.textAlign = st.align;
    }
    if (item.css) {
      item.css.split(';').forEach((rule) => {
        const [k, v] = rule.split(':').map((x) => x && x.trim());
        if (k && v) el.style.setProperty(k, v);
      });
    }
    if (item.className) item.className.split(/\s+/).forEach((c) => c && el.classList.add(c));
  }

  function thumbSize(item) {
    const s = item.style?.iconSize;
    if (!s) return '42';
    const n = Number(s);
    if (n > 120) return '42';
    return String(n);
  }

  function isHeroImage(item) {
    const n = Number(item.style?.iconSize || 0);
    return item.layout?.display === 'top-down' && n >= 120 && item.image;
  }

  function renderIcon(item, depth = 0) {
    if (isSubmenuListRow(item, depth) && item.icon?.startsWith('ri-')) {
      return `<span class="lgk-navi-slide__media lgk-navi-slide__media--service"${mediaBoxStyle(item)}><i class="${esc(item.icon)} lgk-navi-slide__icon" aria-hidden="true"></i></span>`;
    }
    const thumb = depth === 0 && item.image ? '64' : thumbSize(item);
    if (item.image) {
      const fallback = iconFallbackMarkup(item);
      const fb = fallback
        ? fallback.replace(
            'class="lgk-navi-slide__media"',
            'class="lgk-navi-slide__media lgk-navi-slide__media--fallback" hidden'
          )
        : '';
      return `<span class="lgk-navi-slide__media" style="--lgk-navi-thumb:${esc(thumb)}px${item.style?.iconBoxColor ? `;background:${esc(item.style.iconBoxColor)}` : ''}${item.style?.iconBoxRadius ? `;border-radius:${esc(px(item.style.iconBoxRadius))}` : ''}"><img src="${esc(item.image)}" alt="" width="80" height="80" loading="lazy" decoding="async" onerror="this.style.display='none';var s=this.nextElementSibling;if(s)s.hidden=false;">${fb}</span>`;
    }
    return iconFallbackMarkup(item);
  }

  function renderText(item, hideName) {
    const titleSize = item.style?.textSize ? ` style="font-size:${esc(px(item.style.textSize))}"` : '';
    const name = !hideName && item.name ? `<span class="lgk-navi-slide__name"${titleSize}>${esc(item.name)}</span>` : '';
    const desc = item.description ? `<span class="lgk-navi-slide__desc">${esc(item.description)}</span>` : '';
    if (!name && !desc) return '';
    return `<span class="lgk-navi-slide__body">${name}${desc}</span>`;
  }

  function renderChevron(hasChildren, expandArrow) {
    if (!hasChildren || !expandArrow) return '';
    return `<svg class="lgk-navi-slide__chevron" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>`;
  }

  function renderDivider(item) {
    if (!item.divider) return '';
    const d = item.divider;
    const cls = d.size && Number(d.size) >= 4 ? ' lgk-navi-slide__divider--thick' : '';
    const style = [
      d.color ? `border-color:${d.color}` : '',
      d.type ? `border-style:${d.type}` : '',
      d.size ? `border-width:0 0 ${d.size}px` : '',
    ]
      .filter(Boolean)
      .join(';');
    return `<hr class="lgk-navi-slide__divider${cls}"${style ? ` style="${style}"` : ''}>`;
  }

  function renderBrand(item, shopLogo) {
    const st = item.style || {};
    const bg = st.bgImage || BG_TEXTURE;
    const img = item.image || shopLogo || '';
    const iconSize = Number(st.iconSize) || 52;
    const isLeftRight = item.layout?.display === 'left-right' || st.align === 'left';
    const isTopDownBrand = item.layout?.display === 'top-down' && !isLeftRight;
    /* top-down (crest Wayne/Candy) : éviter width=height HTML qui force un crop carré */
    const logo = img
      ? `<img class="lgk-navi-slide__brand-logo" src="${esc(img)}" alt="${esc(item.name)}" width="${isTopDownBrand ? Math.max(iconSize, 160) : iconSize}"${isTopDownBrand ? '' : ` height="${iconSize}"`} loading="eager" onerror="this.style.display='none'">`
      : '';
    const name = item.name ? `<p class="lgk-navi-slide__brand-name">${esc(item.name)}</p>` : '';
    const desc = item.description ? `<p class="lgk-navi-slide__brand-desc">${esc(item.description)}</p>` : '';
    const layoutCls = isLeftRight ? ' lgk-navi-slide__brand--left-right' : '';
    const bgStyle = bg ? ` style="background-image:url(${esc(bg)})"` : '';
    if (isLeftRight) {
      const media = logo ? `<div class="lgk-navi-slide__brand-media">${logo}</div>` : '';
      const text = name || desc ? `<div class="lgk-navi-slide__brand-text">${name}${desc}</div>` : '';
      return `<div class="lgk-navi-slide__brand${layoutCls}"${bgStyle}>${media}${text}</div>`;
    }
    return `<div class="lgk-navi-slide__brand${layoutCls}"${bgStyle}>${logo}${name}${desc}</div>`;
  }

  function renderBrandArticle(item) {
    const img = item.image
      ? `<img class="lgk-navi-slide__brand-article-img" src="${esc(item.image)}" alt="${esc(item.name)}" loading="lazy" decoding="async" onerror="this.remove()">`
      : '';
    const name = item.name ? `<p class="lgk-navi-slide__brand-name">${esc(item.name)}</p>` : '';
    const desc = item.description ? `<p class="lgk-navi-slide__brand-desc">${esc(item.description)}</p>` : '';
    return `<div class="lgk-navi-slide__brand lgk-navi-slide__brand--article">${img}${name}${desc}</div>`;
  }

  function widthColSpan(width, inSubmenu = false) {
    if (!width || width === 'auto' || width === 'hug') return inSubmenu ? 4 : 12;
    if (width === 'fixed') return 12;
    const m12 = String(width).match(/^(\d+)-12$/);
    if (m12) return Math.min(12, Math.max(1, parseInt(m12[1], 10)));
    const m10 = String(width).match(/^(\d+)-10$/);
    if (m10) return Math.min(12, Math.max(1, Math.round((parseInt(m10[1], 10) / 10) * 12)));
    return inSubmenu ? 4 : 12;
  }

  function widthColClass(width, inSubmenu = false) {
    return ` lgk-navi-slide__item--span-${widthColSpan(width, inSubmenu)}`;
  }

  function isBlogArticleUrl(item) {
    if (item.className?.includes('lgk-navi-blog-article')) return true;
    return /\/blogs\/[^/]+\/[^/?#]+/.test(item.url || '');
  }

  function isBlogArticle(item, depth) {
    if (depth < 2 || item.children?.length) return false;
    return isBlogArticleUrl(item);
  }

  function isBlogCategory(item) {
    if (!item.children?.length) return false;
    if (item.className?.includes('lgk-navi-blog-category')) return true;
    return item.children.some((c) => isBlogArticleUrl(c));
  }

  function isBlogHub(item) {
    if (!item.children?.length) return false;
    return item.children.every((c) => isBlogCategory(c));
  }

  function itemColClass(depth, item) {
    if (depth > 0) {
      if (item.kind === 2 || isSubmenuListRow(item, depth)) {
        return ' lgk-navi-slide__item--span-12';
      }
      if (isBlogArticle(item, depth)) {
        return ' lgk-navi-slide__item--span-12';
      }
      const explicitSpan = widthColSpan(item.layout?.width || 'auto', true);
      if (explicitSpan >= 12) {
        return ' lgk-navi-slide__item--span-12';
      }
      if (item.kind === 1 && item.image && !isSubmenuListRow(item, depth)) {
        return ' lgk-navi-slide__item--span-4';
      }
      if (item.kind === 4 && !isBlogCategory(item)) {
        return ' lgk-navi-slide__item--span-4';
      }
      return widthColClass(item.layout?.width || 'auto', true);
    }
    return widthColClass(item.layout?.width || 'auto');
  }

  function renderCategoryTile(item, fullWidth = false) {
    const img = item.image
      ? `<img class="lgk-navi-slide__brand-article-img" src="${esc(item.image)}" alt="${esc(item.name)}" loading="lazy" decoding="async" onerror="this.style.display='none'">`
      : '';
    const name = item.name ? `<p class="lgk-navi-slide__brand-name">${esc(item.name)}</p>` : '';
    const extra = fullWidth ? ' lgk-navi-slide__brand--collection-banner' : '';
    const label = fullWidth && name
      ? `<div class="lgk-navi-slide__collection-banner-label"${item.style?.bgImage ? ` style="background-image:url('${esc(item.style.bgImage)}')"` : ''}>${name}</div>`
      : name;
    return `<div class="lgk-navi-slide__brand lgk-navi-slide__brand--article lgk-navi-slide__brand--category-tile${extra}">${img}${fullWidth ? label : name}</div>`;
  }

  function renderCategoryTileExpandable(item, expandArrow) {
    const inner = renderCategoryTile(item);
    const href = resolveActionUrl(item.url);
    const expandLabel = isBlogCategory(item) ? 'Voir les articles' : 'Afficher le sous-menu';
    return `<div class="lgk-navi-slide__category-tile-split">
      <a class="lgk-navi-slide__brand-link lgk-navi-slide__category-tile-link" href="${esc(href)}">${inner}</a>
      <button type="button" class="lgk-navi-slide__category-tile-expand" data-navi-toggle="${esc(item.id)}" aria-expanded="false" aria-label="${esc(expandLabel)}">${renderChevron(true, expandArrow)}</button>
    </div>`;
  }

  function isSubmenuFullWidthBanner(item, depth) {
    if (depth === 0 || item.kind !== 1 || !item.image) return false;
    if (isSubmenuListRow(item, depth)) return false;
    return widthColSpan(item.layout?.width || 'auto', true) >= 12;
  }

  function isSubmenuListRow(item, depth) {
    if (depth === 0 || item.kind !== 1) return false;
    return Boolean(item.description && /À partir de\s*[\d€]/i.test(item.description));
  }

  function isSubmenuCategoryTile(item, depth) {
    if (depth === 0) return false;
    if (isBlogArticle(item, depth)) return false;
    if (isSubmenuListRow(item, depth)) return false;
    if (isSubmenuFullWidthBanner(item, depth)) return false;
    if (item.kind === 1 && item.image) return true;
    if (item.kind === 4 && item.layout?.display === 'top-down' && item.image) return true;
    return false;
  }

  function useGridTile(item, depth) {
    if (isBlogArticle(item, depth)) return false;
    if (depth > 0) {
      if (item.kind === 2) return false;
      if (isSubmenuListRow(item, depth)) return false;
      if (isSubmenuCategoryTile(item, depth)) return false;
      if (item.kind === 4 && item.image) return true;
      if (item.layout?.display === 'top-down' && item.image) return true;
      return false;
    }
    const span = widthColSpan(item.layout?.width || 'auto');
    if (span >= 12) return false;
    const layout = item.layout?.display || '';
    if (layout === 'top-down') return true;
    if (item.kind === 4 && item.image) return true;
    if (item.image && span <= 6) return true;
    return false;
  }

  function resolveActionUrl(url) {
    if (!url) return '';
    const pageUrl = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title || '');
    if (url === 'share:Facebook') {
      return `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
    }
    if (url === 'share:Tweet' || url === 'share:X') {
      return `https://x.com/intent/post?url=${pageUrl}&text=${title}`;
    }
    if (url === 'share:CopyUrl' || url === 'copy:URL') {
      return '#lgk-navi-copy-url';
    }
    if (url === 'open:ShareMe') {
      if (navigator.share) return '#lgk-navi-native-share';
      return `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
    }
    if (url === 'open:Inbox') {
      return '#lgk-navi-chat';
    }
    return url;
  }

  function handleSpecialLink(link, event) {
    const href = link.getAttribute('href') || '';
    if (href === '#lgk-navi-copy-url') {
      event.preventDefault();
      navigator.clipboard?.writeText(window.location.href).catch(() => {});
      return true;
    }
    if (href === '#lgk-navi-native-share') {
      event.preventDefault();
      navigator.share?.({ url: window.location.href, title: document.title }).catch(() => {});
      return true;
    }
    if (href === '#lgk-navi-chat') {
      event.preventDefault();
      document.querySelector('[data-chat-widget], .shopify-chat, #ShopifyChat, inbox-online-store-chat')?.click();
      return true;
    }
    return false;
  }

  function renderSpacer(item) {
    const el = document.createElement('li');
    el.className = 'lgk-navi-slide__item lgk-navi-slide__item--span-12 lgk-navi-slide__item--spacer';
    el.dataset.naviId = item.id;
    el.setAttribute('aria-hidden', 'true');
    const h = item.heightFix || 8;
    el.innerHTML = `<div class="lgk-navi-slide__spacer" style="height:${esc(px(h))}"></div>`;
    return el;
  }

  function gridSpanClass(width) {
    return widthColClass(width).trim();
  }

  function renderGridTile(item, expandArrow, depth = 0) {
    const hasChildren = item.children && item.children.length > 0;
    const layout = item.layout?.display || '';
    const inSubmenu = depth > 0;
    let media = '';

    if (item.image && (inSubmenu || layout !== 'text-only')) {
      const imgSrc = withImageWidth(item.image, inSubmenu ? 400 : 720);
      media = `<span class="lgk-navi-slide__grid-tile-media"><img src="${esc(imgSrc)}" alt="" width="720" height="480" loading="lazy" decoding="async" onerror="this.closest('.lgk-navi-slide__grid-tile-media')?.remove()"></span>`;
    } else if (item.icon && item.icon.startsWith('ri-')) {
      const iconColor = item.style?.iconColor ? ` style="color:${esc(item.style.iconColor)}"` : '';
      media = `<span class="lgk-navi-slide__grid-tile-media lgk-navi-slide__grid-tile-media--icon"${mediaBoxStyle(item)}><i class="${esc(item.icon)}"${iconColor} aria-hidden="true"></i></span>`;
    }

    const name = item.name
      ? `<span class="lgk-navi-slide__grid-tile-name">${esc(item.name)}</span>`
      : '';
    const chev =
      hasChildren && expandArrow
        ? `<span class="lgk-navi-slide__grid-tile-chevron" aria-hidden="true">${renderChevron(true, true)}</span>`
        : '';
    const body = `${media}${name}${chev}`;

    if (hasChildren) {
      return `<button type="button" class="lgk-navi-slide__grid-tile" data-navi-toggle="${esc(item.id)}">${body}</button>`;
    }
    if (item.url) {
      const href = resolveActionUrl(item.url);
      return `<a class="lgk-navi-slide__grid-tile" href="${esc(href)}">${body}</a>`;
    }
    if (body) {
      return `<div class="lgk-navi-slide__grid-tile">${body}</div>`;
    }
    return '';
  }

  function renderBrandBlock(item, expandArrow, shopLogo, opts = {}) {
    const hasChildren = item.children && item.children.length > 0;
    const suppressToggle = opts.suppressToggle === true;
    /* Ne pas traiter les headers marque (crest Wayne/Candy/…) comme articles :
       sinon → brand-article-img + object-fit:cover = logo coupé. */
    const isBrandHeader =
      /(?:^|\s)lgk-navi-[\w-]*brand(?:\s|$)/i.test(item.className || '') ||
      /(?:^|-)brand$/i.test(item.id || '');
    const isArticle =
      !hasChildren &&
      !isBrandHeader &&
      item.layout?.display === 'top-down' &&
      item.image &&
      item.url;
    const content = isArticle ? renderBrandArticle(item) : renderBrand(item, shopLogo);

    if (hasChildren && !suppressToggle) {
      return `<button type="button" class="lgk-navi-slide__brand-btn" data-navi-toggle="${esc(item.id)}">${content}${renderChevron(true, expandArrow)}</button>`;
    }
    if (hasChildren && suppressToggle) {
      return `<div class="lgk-navi-slide__brand">${content}</div>`;
    }
    if (item.url) {
      const href = resolveActionUrl(item.url);
      return `<a class="lgk-navi-slide__brand-link" href="${esc(href)}">${content}</a>`;
    }
    return content;
  }

  function appendHeroToSection(el, heroItem, expandArrow) {
    if (!heroItem?.image || !isHeroImage(heroItem)) return;
    let heroHtml;
    const img = heroItem.image
      ? `<img class="lgk-navi-slide__hero-img" src="${esc(heroItem.image)}" alt="${esc(heroItem.name)}" loading="lazy" decoding="async" onerror="this.style.display='none'">`
      : '';
    if (isBlogHub(heroItem) && heroItem.url && img) {
      const href = resolveActionUrl(heroItem.url);
      heroHtml = `<a class="lgk-navi-slide__hero-wrap lgk-navi-slide__hero-link" href="${esc(href)}">${img}</a>`;
    } else {
      heroHtml = renderHero(heroItem, true, expandArrow, {
        hideLabel: true,
        toggleId: heroItem.id,
      });
    }
    if (!heroHtml) return;
    const holder = document.createElement('div');
    holder.innerHTML = heroHtml;
    const hero = holder.firstElementChild;
    if (!hero) return;
    applyItemStyle(hero, heroItem);
    el.appendChild(hero);
  }

  function renderSectionBar(item, depth, nextItem, expandArrow, shopLogo) {
    const el = document.createElement('li');
    el.className = `lgk-navi-slide__item${itemColClass(depth, item)}`;
    el.dataset.naviId = item.id;
    const expandable = nextItem?.children?.length > 0;
    const heroToggle = expandable && isHeroImage(nextItem);

    if (heroToggle) {
      const bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'lgk-navi-slide__section-bar lgk-navi-slide__section-bar--toggle';
      bar.setAttribute('data-navi-toggle', nextItem.id);
      bar.innerHTML = `<span class="lgk-navi-slide__section-bar-text">${esc(item.name || '')}</span>${renderChevron(true, expandArrow)}`;
      applyItemStyle(bar, item);
      el.appendChild(bar);
      appendHeroToSection(el, nextItem, expandArrow);
      attachSubmenu(el, nextItem, expandArrow, shopLogo, depth);
    } else {
      const bar = document.createElement('div');
      bar.className = 'lgk-navi-slide__section-bar';
      bar.textContent = item.name || '';
      applyItemStyle(bar, item);
      el.appendChild(bar);
    }

    const divider = renderDivider(item);
    if (divider) {
      const holder = document.createElement('div');
      holder.innerHTML = divider;
      if (holder.firstChild) el.appendChild(holder.firstChild);
    }
    return el;
  }

  function sectionBarHandlesToggle(siblings, index) {
    if (!siblings || index <= 0) return false;
    const prev = siblings[index - 1];
    const item = siblings[index];
    return prev?.kind === 2 && item?.children?.length > 0;
  }

  function renderHero(item, hasChildren, expandArrow, opts = {}) {
    const toggleId = opts.toggleId || item.id;
    const img = item.image
      ? `<img class="lgk-navi-slide__hero-img" src="${esc(item.image)}" alt="${esc(item.name)}" loading="lazy" decoding="async" onerror="this.style.display='none'">`
      : '';
    const interactive = hasChildren && !opts.suppressToggle;
    const showLabel = hasChildren && item.name && !opts.hideLabel;
    const label = showLabel
      ? `<span class="lgk-navi-slide__hero-label"><span class="lgk-navi-slide__name">${esc(item.name)}</span>${renderChevron(interactive, expandArrow)}</span>`
      : '';

    if (interactive) {
      return `<button type="button" class="lgk-navi-slide__hero-wrap lgk-navi-slide__hero-btn" data-navi-toggle="${esc(toggleId)}" aria-expanded="false">${img}${label}</button>`;
    }
    if (hasChildren && opts.suppressToggle) {
      return `<div class="lgk-navi-slide__hero-wrap">${img}${label}</div>`;
    }
    if (!item.image) return '';
    if (item.url) {
      return `<a class="lgk-navi-slide__hero" href="${esc(resolveActionUrl(item.url))}">${img}</a>`;
    }
    return `<div class="lgk-navi-slide__hero">${img}</div>`;
  }

  function attachSubmenu(wrap, item, expandArrow, shopLogo, depth) {
    if (!item.children?.length) return;
    const trigger = wrap.querySelector('[data-navi-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    wrap.querySelectorAll('.lgk-navi-slide__hero-btn[data-navi-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });

    const sub = document.createElement('ul');
    sub.className = 'lgk-navi-slide__submenu lgk-navi-slide__submenu--grid3';
    if (isBlogCategory(item)) sub.classList.add('lgk-navi-slide__submenu--blog-articles');
    sub.setAttribute('role', 'list');
    sub.hidden = true;
    /* Grille 3×3 : styles via CSS (pas display inline — casse [hidden]) */
    sub.style.gridTemplateColumns = 'repeat(12, minmax(0, 1fr))';
    sub.style.gridAutoFlow = 'row';
    sub.style.gridAutoRows = 'min-content';
    sub.style.alignItems = 'start';
    sub.style.alignContent = 'start';
    sub.style.gap = '0.35rem';
    sub.style.width = '100%';
    sub.style.maxWidth = '100%';
    sub.style.overflowX = 'hidden';

    item.children.forEach((child, childIndex) => {
      const node = renderItem(child, expandArrow, shopLogo, depth + 1, item.children, childIndex);
      if (node) sub.appendChild(node);
    });

    if (sub.children.length) wrap.appendChild(sub);
  }

  function renderItemContent(item, expandArrow, shopLogo, depth, opts = {}) {
    const hasChildren = item.children && item.children.length > 0;
    const layout = item.layout?.display || '';
    const inSubmenu = depth > 0;
    const suppressToggle = opts.suppressToggle === true;

    if (inSubmenu && isBlogArticle(item, depth)) {
      const rowClass = 'lgk-navi-slide__row--left-right lgk-navi-slide__row--blog-article';
      const media = item.image
        ? `<span class="lgk-navi-slide__media lgk-navi-slide__media--blog-thumb"><img src="${esc(item.image)}" alt="" width="72" height="54" loading="lazy" decoding="async" onerror="this.closest('.lgk-navi-slide__media')?.remove()"></span>`
        : '';
      const text = renderText(item);
      const href = resolveActionUrl(item.url);
      if (href) {
        return `<a class="lgk-navi-slide__row ${rowClass}" href="${esc(href)}">${media}${text}</a>`;
      }
      return `<div class="lgk-navi-slide__row ${rowClass}">${media}${text}</div>`;
    }

    if (inSubmenu && isSubmenuFullWidthBanner(item, depth)) {
      const inner = renderCategoryTile(item, true);
      const href = resolveActionUrl(item.url);
      if (href) {
        return `<a class="lgk-navi-slide__brand-link lgk-navi-slide__brand-link--banner" href="${esc(href)}">${inner}</a>`;
      }
      return inner;
    }

    if (inSubmenu && isSubmenuCategoryTile(item, depth)) {
      const inner = renderCategoryTile(item);
      if (hasChildren && !suppressToggle) {
        const href = resolveActionUrl(item.url);
        if (href) {
          return renderCategoryTileExpandable(item, expandArrow);
        }
        return `<button type="button" class="lgk-navi-slide__category-tile-btn lgk-navi-slide__brand-link" data-navi-toggle="${esc(item.id)}">${inner}${renderChevron(true, expandArrow)}</button>`;
      }
      const href = resolveActionUrl(item.url);
      if (href) {
        return `<a class="lgk-navi-slide__brand-link" href="${esc(href)}">${inner}</a>`;
      }
      return inner;
    }

    if (inSubmenu && useGridTile(item, depth)) {
      return renderGridTile(item, expandArrow, depth);
    }

    if (item.kind === 4) {
      if (useGridTile(item, depth)) return renderGridTile(item, expandArrow, depth);
      return renderBrandBlock(item, expandArrow, shopLogo, opts);
    }

    if (isHeroImage(item) && !inSubmenu) {
      return renderHero(item, hasChildren, expandArrow, opts);
    }

    if (
      !inSubmenu &&
      hasChildren &&
      layout === 'top-down' &&
      Number(item.style?.iconSize || 0) >= 120
    ) {
      const hero = renderHero(item, hasChildren, expandArrow, opts);
      if (hero) return hero;
    }

    if (useGridTile(item, depth)) {
      return renderGridTile(item, expandArrow, depth);
    }

    const rowClass =
      layout === 'top-down' ? 'lgk-navi-slide__row--top-down' : 'lgk-navi-slide__row--left-right';
    const media = layout !== 'text-only' ? renderIcon(item, depth) : '';
    const text = layout !== 'icon-image-only' ? renderText(item, isHeroImage(item)) : '';

    if (hasChildren && !suppressToggle) {
      return `<button type="button" class="lgk-navi-slide__row-btn lgk-navi-slide__row ${rowClass}" data-navi-toggle="${esc(item.id)}">${media}${text}${renderChevron(true, expandArrow)}</button>`;
    }
    if (hasChildren && suppressToggle) {
      return `<div class="lgk-navi-slide__row ${rowClass}">${media}${text}</div>`;
    }
    const href = resolveActionUrl(item.url);
    if (href) {
      return `<a class="lgk-navi-slide__row ${rowClass}" href="${esc(href)}">${media}${text}</a>`;
    }
    if (item.name || item.description || media) {
      return `<div class="lgk-navi-slide__row ${rowClass}">${media}${text}</div>`;
    }
    return '';
  }

  function renderItem(item, expandArrow, shopLogo, depth = 0, siblings = null, index = 0) {
    if (item.kind === 3) {
      if (depth > 0) return null;
      return renderSpacer(item);
    }
    if (item.kind === 2) {
      const nextItem = siblings?.[index + 1];
      return renderSectionBar(item, depth, nextItem, expandArrow, shopLogo);
    }

    const toggleOnPrevSection = sectionBarHandlesToggle(siblings, index);
    if (toggleOnPrevSection && isHeroImage(item)) return null;

    const hasChildren = item.children && item.children.length > 0;
    const widthCls = itemColClass(depth, item);
    const inner = renderItemContent(item, expandArrow, shopLogo, depth, {
      suppressToggle: false,
    });

    if (!inner) return null;

    const wrap = document.createElement('li');
    wrap.className = `lgk-navi-slide__item${widthCls}`;
    wrap.dataset.naviId = item.id;
    if (item.className) {
      item.className.split(/\s+/).forEach((c) => c && wrap.classList.add(c));
    }
    if (isBlogCategory(item)) wrap.classList.add('lgk-navi-blog-category');
    wrap.innerHTML = inner + renderDivider(item);
    const target = wrap.querySelector(
      '.lgk-navi-slide__row, .lgk-navi-slide__row-btn, .lgk-navi-slide__brand, .lgk-navi-slide__brand-btn, .lgk-navi-slide__brand-link, .lgk-navi-slide__category-tile-btn, .lgk-navi-slide__category-tile-link, .lgk-navi-slide__category-tile-split, .lgk-navi-slide__hero, .lgk-navi-slide__hero-btn, .lgk-navi-slide__hero-wrap, .lgk-navi-slide__grid-tile'
    );
    if (target) {
      const compactTile =
        depth > 0 &&
        (target.classList.contains('lgk-navi-slide__grid-tile') ||
          target.classList.contains('lgk-navi-slide__category-tile-btn'));
      applyItemStyle(target, item, compactTile ? { compact: true } : {});
    }
    if (hasChildren) attachSubmenu(wrap, item, expandArrow, shopLogo, depth);
    return wrap;
  }

  function buildItemMap(items, map = {}) {
    items.forEach((item) => {
      map[item.id] = item;
      if (item.children?.length) buildItemMap(item.children, map);
    });
    return map;
  }

  function suppressNativeSidebar() {
    const sidebar = document.getElementById('sidebar-menu');
    if (!sidebar || sidebar.dataset.lgkNaviHooked === '1') return;
    sidebar.dataset.lgkNaviHooked = '1';
    sidebar.addEventListener(
      'dialog:before-show',
      (e) => {
        if (document.getElementById('lgk-navi-slide')) e.preventDefault();
      },
      true
    );
    if (typeof sidebar.hide === 'function') sidebar.hide();
  }

  function neutralizeNaviPlus() {
    const selectors = [
      'navi-menu-builder',
      '[id*="navi-menu"]',
      '[class*="navi-menu"]',
      '[class*="naviplus"]',
      '[id^="SF-"]',
      '.shopify-app-block [id^="SF-"]',
      'iframe[src*="naviplus"]',
    ];
    document.querySelectorAll(selectors.join(', ')).forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('z-index', '-1', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
    if (typeof window.NaviMenu === 'function') {
      try {
        window.NaviMenu = function () {};
      } catch (_) {
        /* ignore */
      }
    }
  }

  function mountPortal(root) {
    if (!root || root.dataset.lgkMounted === '1') return;
    document.body.appendChild(root);
    root.dataset.lgkMounted = '1';
  }

  function showOpenState(root) {
    mountPortal(root);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    root.style.visibility = 'visible';
    root.style.opacity = '1';
    root.style.pointerEvents = 'auto';
    root.style.zIndex = '2147483646';
    document.documentElement.classList.add('lgk-navi-open');
    lockBodyScroll();
    setTriggersExpanded(true);
  }

  function hideOpenState(root) {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    root.style.visibility = '';
    root.style.opacity = '';
    root.style.pointerEvents = '';
    root.style.zIndex = '';
    document.documentElement.classList.remove('lgk-navi-open');
    unlockBodyScroll();
    setTriggersExpanded(false);
  }

  function closeMenu(root) {
    if (naviInstance) {
      naviInstance.close();
    } else if (root) {
      hideOpenState(root);
    }
  }

  function bindEarlyClose(root) {
    if (!root || root.dataset.lgkEarlyClose === '1') return;
    root.dataset.lgkEarlyClose = '1';
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-navi-close]')) {
        e.preventDefault();
        closeMenu(root);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeMenu(root);
    });
  }

  function ensureLoadingPanel(panelsEl) {
    if (!panelsEl || panelsEl.querySelector('.lgk-navi-slide__panel')) return;
    panelsEl.innerHTML =
      '<div class="lgk-navi-slide__panel is-active"><div class="lgk-navi-slide__scroller"><p class="lgk-navi-slide__loading" role="status">Chargement du menu</p></div></div>';
  }

  function setTriggersExpanded(open) {
    document.querySelectorAll(TRIGGER).forEach((btn) => {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  let scrollLockY = 0;

  function lockBodyScroll() {
    scrollLockY = window.scrollY || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollLockY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  function trapFocus(root) {
    const focusable =
      'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
    const nodes = () => [...root.querySelectorAll(focusable)].filter((el) => el.offsetParent !== null);
    return (e) => {
      if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
      const list = nodes();
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
  }

  function bindSwipeClose(root, onClose) {
    if (!root || root.dataset.lgkSwipe === '1') return;
    root.dataset.lgkSwipe = '1';
    const drawer = root.querySelector('.lgk-navi-slide__drawer');
    if (!drawer) return;
    let startX = 0;
    let startY = 0;
    drawer.addEventListener(
      'touchstart',
      (e) => {
        const t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
      },
      { passive: true }
    );
    drawer.addEventListener(
      'touchend',
      (e) => {
        const t = e.changedTouches[0];
        const dx = t.clientX - startX;
        const dy = Math.abs(t.clientY - startY);
        if (dx < -70 && dy < 50) onClose();
      },
      { passive: true }
    );
  }

  class LgkNaviSlide {
    constructor(root, data) {
      this.root = root;
      this.data = data;
      this.shopLogo = root.dataset.shopLogo || '';
      this.setting = data.setting || {};
      this.itemMap = buildItemMap(data.items || []);
      this.stack = [];
      this.panelsEl = root.querySelector('[data-navi-panels]');
      this.drawer = root.querySelector('.lgk-navi-slide__drawer');
      this.ready = false;
      this.applySettings();
      this.bind();
      this.buildRootPanel(data.items || []);
      this.ready = true;
    }

    applySettings() {
      const s = this.setting;
      const r = this.root;
      if (s.textColor) r.style.setProperty('--lgk-navi-text', s.textColor);
      if (s.backgroundColor) r.style.setProperty('--lgk-navi-bg', s.backgroundColor);
      if (s.submenuBackgroundColor) r.style.setProperty('--lgk-navi-sub-bg', s.submenuBackgroundColor);
      if (s.dividerColor) r.style.setProperty('--lgk-navi-divider', s.dividerColor);
      if (s.iconColor) r.style.setProperty('--lgk-navi-icon', s.iconColor);
      if (s.highlightColor) r.style.setProperty('--lgk-navi-accent', s.highlightColor);
      else if (s.badgeColor) r.style.setProperty('--lgk-navi-accent', s.badgeColor);
      if (s.textSize) r.style.setProperty('--lgk-navi-text-size', px(s.textSize));
      if (s.iconSize) r.style.setProperty('--lgk-navi-icon-size', px(s.iconSize));
      if (s.height) r.style.setProperty('--lgk-navi-item-h', px(s.height));
      if (s.closeIconTop) r.style.setProperty('--lgk-navi-close-top', px(s.closeIconTop));
      /* submenuWidth Navi+ (200) = ancien flyout étroit ; accordéon = pleine largeur du drawer */
      r.style.setProperty('--lgk-navi-submenu-width', '100%');
      if (s.submenuMaxHeight) {
        const h = Number(s.submenuMaxHeight);
        if (h > 0) r.style.setProperty('--lgk-navi-submenu-max-h', `${h}px`);
      }
      if (s.backgroundImage) r.style.setProperty('--lgk-navi-bg-texture', `url(${s.backgroundImage})`);
      if (s.bottomMargin) r.style.setProperty('--lgk-navi-bottom-margin', px(s.bottomMargin));
      if (s.level1Dropshadow === false) r.classList.add('lgk-navi-slide--no-shadow');
      if (s.zIndex) this.root.style.zIndex = s.zIndex;
      if (s.cssCode) {
        let style = document.getElementById('lgk-navi-custom-css');
        if (!style) {
          style = document.createElement('style');
          style.id = 'lgk-navi-custom-css';
          document.head.appendChild(style);
        }
        style.textContent = s.cssCode.replace(/\.lgk-navi-slide/g, '#lgk-navi-slide');
      }
    }

    bind() {
      this.onFocusTrap = trapFocus(this.root);
      document.addEventListener('keydown', this.onFocusTrap);

      this.root.querySelector('.lgk-navi-slide__overlay')?.addEventListener('click', () => this.close());
      this.root.addEventListener('click', (e) => {
        const close = e.target.closest('[data-navi-close]');
        if (close) {
          e.preventDefault();
          this.close();
          return;
        }
        const back = e.target.closest('[data-navi-back]');
        if (back) {
          e.preventDefault();
          this.collapseAllSubmenus();
          return;
        }
        const link = e.target.closest(
          'a.lgk-navi-slide__row, a.lgk-navi-slide__hero, a.lgk-navi-slide__hero-link, a.lgk-navi-slide__brand-link, a.lgk-navi-slide__grid-tile, a.lgk-navi-slide__category-tile-link'
        );
        if (link && link.href) {
          if (handleSpecialLink(link, e)) return;
          if (link.getAttribute('href')?.startsWith('#')) return;
          this.close();
          return;
        }
        const toggle = e.target.closest('[data-navi-toggle]');
        if (toggle) {
          e.preventDefault();
          this.toggleSubmenu(toggle);
        }
      });
      this.onEscape = (e) => {
        if (e.key === 'Escape' && this.root.classList.contains('is-open')) {
          if (this.collapseAllSubmenus()) return;
          this.close();
        }
      };
      document.addEventListener('keydown', this.onEscape);

      bindSwipeClose(this.root, () => this.close());
    }

    toggleSubmenu(trigger) {
      const li = trigger.closest('.lgk-navi-slide__item');
      const sub = li?.querySelector(':scope > .lgk-navi-slide__submenu');
      if (!sub) return;

      const willOpen = sub.hidden;
      if (willOpen) {
        const parentSub = li.parentElement?.closest('.lgk-navi-slide__submenu');
        if (parentSub) {
          parentSub.querySelectorAll(':scope > .lgk-navi-slide__item.is-expanded').forEach((sibling) => {
            if (sibling === li) return;
            const sibSub = sibling.querySelector(':scope > .lgk-navi-slide__submenu');
            const sibBtn = sibling.querySelector('[data-navi-toggle]');
            if (sibSub) sibSub.hidden = true;
            sibling.classList.remove('is-expanded');
            sibBtn?.setAttribute('aria-expanded', 'false');
          });
        }
      }

      sub.hidden = !willOpen;
      li.classList.toggle('is-expanded', willOpen);
      li.querySelectorAll('[data-navi-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      if (willOpen) {
        requestAnimationFrame(() => {
          sub.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
      }
    }

    collapseAllSubmenus() {
      const expanded = this.root.querySelectorAll('.lgk-navi-slide__item.is-expanded');
      if (!expanded.length) return false;
      expanded.forEach((li) => {
        const sub = li.querySelector(':scope > .lgk-navi-slide__submenu');
        const btn = li.querySelector('[data-navi-toggle]');
        if (sub) sub.hidden = true;
        li.classList.remove('is-expanded');
        btn?.setAttribute('aria-expanded', 'false');
      });
      return true;
    }

    buildRootPanel(items) {
      this.panelsEl.innerHTML = '';
      this.stack = [];

      const panel = document.createElement('div');
      panel.className = 'lgk-navi-slide__panel is-active';
      panel.innerHTML = `<button type="button" class="lgk-navi-slide__close close-icon" data-navi-close aria-label="Fermer"><svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></button>`;

      const scroller = document.createElement('div');
      scroller.className = 'lgk-navi-slide__scroller';

      /* Cross-vitrines gérées par l'encart dédié (lgk-navi-sister-stores) */
      const rootItems = (items || []).filter(
        (item) => !(item.className || '').includes('lgk-navi-cross-storefront')
      );

      /* Marque LEGEEKSHOP.COM tout en haut, puis encart boutiques, puis catalogue */
      let brandEnd = 0;
      if (rootItems.length) {
        const first = rootItems[0];
        if (
          first.id === 'nav-11719147' ||
          /legeekshop\.com/i.test(first.name || '') ||
          (first.kind === 4 && /legeekshop/i.test(first.name || ''))
        ) {
          brandEnd = 1;
          if (rootItems[1]?.kind === 3) brandEnd = 2;
        }
      }
      const headItems = rootItems.slice(0, brandEnd);
      const tailItems = rootItems.slice(brandEnd);

      const appendItems = (listEl, slice, offset) => {
        slice.forEach((item, index) => {
          const node = renderItem(
            item,
            this.setting.expandArrowShow !== false,
            this.shopLogo,
            0,
            rootItems,
            offset + index
          );
          if (node) listEl.appendChild(node);
        });
      };

      if (headItems.length) {
        const headList = document.createElement('ul');
        headList.className = 'lgk-navi-slide__list lgk-navi-slide__list--brand';
        headList.setAttribute('role', 'list');
        appendItems(headList, headItems, 0);
        scroller.appendChild(headList);
      }

      const sisterTpl = document.getElementById('lgk-navi-sister-stores-tpl');
      if (sisterTpl?.content) {
        const sister = sisterTpl.content.cloneNode(true);
        const aside = sister.querySelector('.lgk-navi-sister-stores');
        const currentSf = this.root?.dataset?.storefront || 'legeekshop';
        sister.querySelectorAll('[data-storefront]').forEach((item) => {
          if (item.getAttribute('data-storefront') === currentSf) item.remove();
        });
        if (aside) {
          aside.classList.add('lgk-navi-sister-stores--featured');
          aside.dataset.currentStorefront = currentSf;
        }
        if (sister.querySelector('.lgk-navi-sister-stores__item')) {
          scroller.appendChild(sister);
        }
      }

      const list = document.createElement('ul');
      list.className = 'lgk-navi-slide__list';
      list.setAttribute('role', 'list');
      appendItems(list, tailItems, brandEnd);
      scroller.appendChild(list);

      panel.appendChild(scroller);
      this.panelsEl.appendChild(panel);
      this.stack = [panel];
    }

    open() {
      if (!this.ready) return;
      suppressNativeSidebar();
      neutralizeNaviPlus();
      showOpenState(this.root);
      requestAnimationFrame(() => this.root.querySelector('[data-navi-close]')?.focus());
    }

    openShell() {
      showOpenState(this.root);
    }

    close() {
      hideOpenState(this.root);
      this.collapseAllSubmenus();
      const scroller = this.stack[0]?.querySelector('.lgk-navi-slide__scroller');
      if (scroller) scroller.scrollTop = 0;
    }
  }

  let naviInstance = null;
  let dataPromise = null;
  let hamburgerBound = false;

  function handleHamburger(event) {
    const root = document.getElementById('lgk-navi-slide');
    if (!root) return;

    const btn = event.target.closest(TRIGGER);
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (root.classList.contains('is-open')) {
      closeMenu(root);
      return;
    }

    suppressNativeSidebar();
    neutralizeNaviPlus();

    const sidebar = document.getElementById('sidebar-menu');
    if (sidebar && typeof sidebar.hide === 'function') sidebar.hide();

    const openMenu = () => {
      if (naviInstance?.ready) {
        naviInstance.open();
      } else if (naviInstance) {
        naviInstance.openShell();
      }
    };

    showOpenState(root);
    bindEarlyClose(root);
    ensureLoadingPanel(root.querySelector('[data-navi-panels]'));

    if (naviInstance?.ready) {
      openMenu();
      return;
    }

    (dataPromise || loadMenuData(root))
      .then((data) => {
        if (!data) {
          ensureLoadingPanel(root.querySelector('[data-navi-panels]'));
          const loading = root.querySelector('.lgk-navi-slide__loading');
          if (loading) loading.textContent = 'Menu indisponible. Rechargez la page.';
          return;
        }
        try {
          if (!naviInstance) {
            naviInstance = new LgkNaviSlide(root, data);
            window.__lgkNaviSlide = naviInstance;
          }
          naviInstance.open();
        } catch (err) {
          console.error('[LGK Navi Slide] build', err);
          ensureLoadingPanel(root.querySelector('[data-navi-panels]'));
          const loading = root.querySelector('.lgk-navi-slide__loading');
          if (loading) loading.textContent = 'Erreur menu. Rechargez la page.';
        }
      })
      .catch((err) => {
        console.warn('[LGK Navi Slide]', err);
        ensureLoadingPanel(root.querySelector('[data-navi-panels]'));
        const loading = root.querySelector('.lgk-navi-slide__loading');
        if (loading) loading.textContent = 'Erreur réseau. Réessayez.';
      });
  }

  function bindHamburger() {
    if (hamburgerBound) return;
    hamburgerBound = true;
    document.addEventListener('click', handleHamburger, true);
  }

  function loadMenuData(root) {
    if (dataPromise) return dataPromise;

    const pageType = root.dataset.pageType || '';
    const menuUrl = root.dataset.menuUrl;
    if (!menuUrl) {
      dataPromise = Promise.resolve(null);
      return dataPromise;
    }

    dataPromise = fetch(menuUrl)
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then((data) => normalizeMenuData(data, root.dataset.shopLogo || ''));

    return dataPromise;
  }

  function init() {
    document.getElementById('lgk-navi-live-badge')?.remove();

    const root = document.getElementById('lgk-navi-slide');
    if (!root) return;

    ensureRemixIconCss();
    mountPortal(root);
    bindHamburger();
    bindEarlyClose(root);
    bindSwipeClose(root, () => closeMenu(root));
    suppressNativeSidebar();
    neutralizeNaviPlus();

    loadMenuData(root)
      .then((data) => {
        if (!data || naviInstance) {
          if (window.__lgkNaviPendingOpen && naviInstance?.ready) {
            window.__lgkNaviPendingOpen = false;
            naviInstance.open();
          }
          return;
        }
        try {
          naviInstance = new LgkNaviSlide(root, data);
          window.__lgkNaviSlide = naviInstance;
          if (window.__lgkNaviPendingOpen) {
            window.__lgkNaviPendingOpen = false;
            naviInstance.open();
          }
        } catch (err) {
          console.error('[LGK Navi Slide] preload', err);
        }
      })
      .catch((err) => console.warn('[LGK Navi Slide] preload', err));

    const observer = new MutationObserver(neutralizeNaviPlus);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.__lgkNaviOpen = handleHamburger;
  window.__lgkNaviHandleHamburger = handleHamburger;
  bindHamburger();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
